import BusinessIndex from '@/views/business/Index'
import YachtIndex from '@/views/business/yachts/Index'
import YachtDetails from '@/views/business/yachts/Details'
import YachtDashboard from '@/views/business/yachts/details/Dashboard'
import YachtConfiguration from '@/views/business/yachts/details/Configuration'
import YachtDelivery from '@/views/business/yachts/details/Delivery'
import YachtDocuments from '@/views/business/yachts/details/Documents'
import YachtHistory from '@/views/business/yachts/details/History'
import YachtPhotos from '@/views/business/yachts/details/Photos'
import YachtSpecs from '@/views/business/yachts/details/Specs'
import YachtBooking from '@/views/business/yachts/details/Booking'
import YachtComments from '@/views/business/yachts/details/Comments'
import OwnersIndex from '@/views/business/owners/Index'
import LogisticsIndex from '@/views/business/logistics/Index'
import EquipmentLogisticsIndex from '@/views/business/equipmentLogistics/Index'
import YachtModelsPricelistIndex from '@/views/business/yachtModels/Index'
import YachtSalesIndex from '@/views/business/yachtSales/Index'
import LogisticsChecklist from '@/views/business/yachts/details/LogisticsChecklist.vue'
import YachtModelsSalesOffers from '@/views/business/yachtModels/YachtModelsSalesOffers.vue'
import YachtFinanceDetails from '@/views/business/yachts/details/FinanceDetails.vue'
import YachtsCashFlowIndex from '@/views/business/cashflow/Index'

export default [
  {
    path: '/business',
    name: 'business',
    redirect: { name: 'yachts' },
    component: BusinessIndex,
    children: [
      {
        path: 'yachts',
        name: 'yachts',
        component: YachtIndex
      },
      {
        path: 'yacht/:id',
        component: YachtDetails,
        children: [
          {
            path: '',
            name: 'yachtDashboard',
            component: YachtDashboard
          },
          {
            path: 'configuration',
            name: 'yachtConfiguration',
            component: YachtConfiguration
          },
          {
            path: 'delivery',
            name: 'yachtDelivery',
            component: YachtDelivery
          },
          {
            path: 'documents',
            name: 'yachtDocuments',
            component: YachtDocuments
          },
          {
            path: 'history',
            name: 'yachtHistory',
            component: YachtHistory
          },
          {
            path: 'booking',
            name: 'yachtBooking',
            component: YachtBooking
          },
          {
            path: 'photos',
            name: 'yachtPhotos',
            component: YachtPhotos
          },
          {
            path: 'specs',
            name: 'yachtSpecs',
            component: YachtSpecs
          },
          {
            path: 'comments',
            name: 'yachtComments',
            component: YachtComments
          },
          {
            path: 'logistics-checklist',
            name: 'yachtLogisticsChecklist',
            component: LogisticsChecklist
          },
          {
            path: 'finance-details',
            name: 'yachtFinanceDetails',
            component: YachtFinanceDetails
          }
        ]
      },
      {
        path: 'yacht-sales-offers',
        name: 'yachtModelsSalesOffers',
        component: YachtModelsSalesOffers
      },
      {
        path: 'yacht-sales',
        name: 'yachtSales',
        component: YachtSalesIndex
      },
      {
        path: 'yacht-models',
        name: 'yachtModelsPricelist',
        component: YachtModelsPricelistIndex
      },
      {
        path: 'owners',
        name: 'owners',
        component: OwnersIndex
      },
      {
        path: 'logistics',
        name: 'logistics',
        component: LogisticsIndex
      },
      {
        path: 'equipment-logistics',
        name: 'equipmentLogistics',
        component: EquipmentLogisticsIndex
      },
      {
        path: 'cash-flow',
        name: 'yachtsCashFlow',
        component: YachtsCashFlowIndex
      }

    ]
  }
]
